import AppButton from "component/Buttons/AppButton";
import PropTypes from "prop-types";
import React from "react";
import { Col, Modal, ModalBody, Row } from "reactstrap";

const DeleteModal = ({
  text = "You won't be able to revert this!",
  show,
  onDeleteClick,
  onCloseClick,
  loading = false,
  label = "Yes, delete it!",
  cancelLabel = "Cancel",
  title = "Are you sure ?",
  icon = <i className='mdi mdi-alert-outline text-warning' style={{ fontSize: "5em" }} />,
  customContent,
  remove = false,
  primaryBtnColor = "danger",
}) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className='py-3 px-5'>
        <Row>
          <Col lg={12}>
            <div className='text-center'>
              {remove ? <i className='bx bx-trash badge-soft-danger rounded-circle p-3 mb-5' style={{ fontSize: "6em" }} /> : icon && icon}
              {title && <h2>{title}</h2>}
              <h5>{text}</h5>
            </div>
          </Col>
        </Row>
        {customContent ? (
          customContent
        ) : (
          <Row>
            <Col>
              <div className='mt-3 d-flex gap-3 justify-content-center'>
                <AppButton label={cancelLabel} color='secondary' disabled={loading} outline onClick={onCloseClick} />
                <AppButton color={primaryBtnColor} isSubmitting={loading} onClick={onDeleteClick} label={loading ? "Processing..." : label} />
              </div>
            </Col>
          </Row>
        )}
      </ModalBody>
    </Modal>
  );
};

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
};

export default DeleteModal;
